import React from "react";

interface HistoryButtonProps {
  handleClick: () => void;
  loading: boolean;
}

const HistoryButton: React.FC<HistoryButtonProps> = ({
  handleClick,
  loading,
}) => {
  return (
    <button
      onClick={handleClick}
      disabled={loading}
      className={`flex w-full items-center justify-center ${
        loading ? "cursor-not-allowed" : "cursor-pointer"
      }`}
    >
      <svg
        width="23"
        height="23"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <g fill={loading ? "#4d525490" : "#4d5254"}>
            <path d="M1.5 1.25a.75.75 0 011.5 0v1.851A7 7 0 111 8a.75.75 0 011.5 0 5.5 5.5 0 101.725-4H5.75a.75.75 0 010 1.5h-3.5a.75.75 0 01-.75-.75v-3.5z"></path>
            <path d="M8.25 4a.75.75 0 01.75.75v3.763l1.805.802a.75.75 0 01-.61 1.37l-2.25-1A.75.75 0 017.5 9V4.75A.75.75 0 018.25 4z"></path>
          </g>
        </g>
      </svg>
    </button>
  );
};

export default HistoryButton;
